import api from '../../../util/api'

const endpoint = "/interface/v1/sync/"

export default {
  async list({ commit }) {
    try {
      const res = await api.get(endpoint);
      const data = await res.json();
      commit("set", { data: data.results });
      commit('getPage', {data: data})
      return data.results;
    } catch (err) {
      return err;
    }
  },
  async listSort({ commit }, { sort }) {
    try {
      const res = await api.get(endpoint + sort);
      const data = await res.json();
      commit("set", { data: data.results });
      commit('getPage', {data: data})
      return data.results;
    } catch (err) {
      return err;
    }
  },
  async get({ commit }, { id }) {
    try {
      const res = await api.get(endpoint + id);
      const data = await res.json();
      commit("show", { data: data.results });
      commit('getPage', {data: data})
      return data.results;
    } catch (err) {
      return err;
    }
  },
  async create({ commit }, { item }) {
    try {
      const res = await api.post(endpoint, item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async update({ commit }, { item }) {
    try {
      const res = await api.put(endpoint + item.id + "/", item);
      const data = await res.json();
      return data;
    } catch (err) {
      return err;
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      const res = await api.delete(endpoint + id);
      dispatch("list");
      return res;
    } catch (err) {
      return err;
    }
  },
}